import { Gesture, gestureLayers } from "./BaseGesture"

class SidebarFileDropToMoveIntoRoots extends Gesture {
  override layer = gestureLayers.sidebar

  override reset() {
    const { state: gestureState } = useGestures()
    gestureState.value.sidebarRootsFileDraggedOver = undefined
  }

  isOverRoots(event: MouseEvent) {
    const { sidebarRootsId } = useGlobals()
    return getFirstMatchingParent(event.target, e => e.id === sidebarRootsId)
  }

  override async onMouseMove(mouse: MouseEvent) {
    const { state: gestureState, getSidebarRootsFromEvent } = useGestures()
    const roots = this.isOverRoots(mouse)
    if (!gestureState.value.mouseDown || gestureState.value.gesture !== "drag-file" || !roots)
      return this.reset()

    // This might be undefined, which is okay
    gestureState.value.sidebarRootsFileDraggedOver = getSidebarRootsFromEvent(mouse)

    if (gestureState.value.sidebarRootsFileDraggedOver)
      console.debug("Hovered over root")

    this.capture()
  }

  override async onMouseUp(mouse: MouseEvent) {
    const { state: gestureState } = useGestures()
    const { selectedFiles, isSelectionEmpty } = useSelection()
    const { moveFiles } = useFileSystem()
    if (gestureState.value.gesture !== "drag-file" || !this.isOverRoots(mouse) || isSelectionEmpty() || !isDefined(gestureState.value.sidebarRootsFileDraggedOver))
      return this.reset()

    const destination = gestureState.value.sidebarRootsFileDraggedOver
    const files = selectedFiles.value

    this.debug("Dropped files over sidebar root, moving them", files, destination)

    moveFiles(selectedFiles.value, gestureState.value.sidebarRootsFileDraggedOver)

    this.reset()
    this.capture()
  }
}

const sidebarFileDropToMoveIntoRoots = new SidebarFileDropToMoveIntoRoots()
export default function () {
  return sidebarFileDropToMoveIntoRoots
}
